<li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
	<a class="icon-Combined-Shape-3">Miles upperClub Terms and Conditions</a>
</li>

<a class="icon-Combined-Shape-3 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Miles upperClub Terms and Conditions</a>
<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}" id="item-2">
	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">MILES UPPERCLUB PROGRAM DEFINITION</h2>

	<div class="container" [ngClass]="{'show': show_description1}">
		<p>
			Miles UpperClub is a platform developed by UpperClub Inc.(referred to generally as “Miles
			UpperClub Administrator”) to First Citizens Bank (hereinafter, the “First Citizens” or “Issuer”)
			and its cardholders (collectively, “Members,” and individually, a “Member,” or “you”) through
			rewards programs (referred to generally as “First Citizens Rewards”) that include benefits
			related to travel content to its members when booking air flights, reserving hotels, car rental, or
			entertainment activities. All these provisions established in this document are part of the
			Terms and Conditions of this Program.
		</p>

		<p>
			<strong>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. YOUR PARTICIPATION
			IN THIS PROGRAM IS SUBJECT TO ALL OF THESE TERMS AND CONDITIONS. BY
			ENROLLING IN THE PROGRAM, YOU AGREE TO BE BOUND BY THESE TERMS AND
			CONDITIONS.</strong>
		</p>
	</div>

	<h2 (click)="toggleClass('2')" [ngClass]="{'open': show_description2}">About First Citizens Rewards</h2>

	<div class="container" [ngClass]="{'show': show_description2}">
		<p>
			First Citizens Rewards was designed for exclusive members looking for quick and effective
			solutions to obtain and receive benefits when using the reward program. It includes Miles
			UpperClub Rewards plus Miles UpperClub Benefits, such as Miles Card, UpperMiles, Pay with
			Miles, and Buy Miles. Which you will find detailed in these Terms and Conditions below:
		</p>
	</div>



	<h2 (click)="toggleClass('3')" [ngClass]="{'open': show_description3}">Miles UpperClub DEFINITIONS</h2>

	<div class="container" [ngClass]="{'show': show_description3}">
		<p>
			<strong>Miles</strong>. Is the rewards points under this Program.
		</p>
		<p>
		<strong>Miles UpperClub</strong>. Is your loyalty platform where you can access different products, services, and benefits offered through the website or app.
		</p>
		<p>
		<strong>Miles card. Use your rewards balance for everyday spend</strong>. Use your Miles card to redeem
			your points anytime and anywhere – just add it to you favorite e-wallet or add it to the checkout
			process when redeeming online.
		</p>
		<p>
		<strong>First Citizens Rewards</strong>. Is the name of the rewards program (“Miles UpperClub program”) brought to you by First Citizens (“Issuer”) powered by Miles UpperClub.
		</p>
	</div>



	<h2 (click)="toggleClass('03')" [ngClass]="{'open': show_description03}">Miles UpperClub ENROLLMENT:</h2>

	<div class="container" [ngClass]="{'show': show_description03}">
		<p>
			To access Miles UpperClub, you must have reached the legal age of majority in their respective
			territory/country of residence, complete the registration, have a valid email address, and
			establish a Miles UpperClub account.
		</p>
		<p>
			It is the member&#39;s responsibility to keep safe the member ID and password and restrict account
			access to any mobile phone number and/or e-mail address registered. The members are solely
			responsible for all transactions and redemption activities in their Miles UpperClub account. Any
			necessary enrollment fees will be established by the Miles UpperClub Administrator.
		</p>
	</div>



	<h2 (click)="toggleClass('4')" [ngClass]="{'open': show_description4}">Miles UpperClub ELEGIBILITY</h2>

	<div class="container" [ngClass]="{'show': show_description4}">
		<p>
			Any individual who is the main cardholder of a valid credit or debit card issued by an Issuer
			licensed by a major credit or debit card network to operate in any territory and good standing
			may be eligible to become a member of the <strong>Miles UpperClub</strong> program.
		</p>
		<p>
			<strong>Miles UpperClub</strong> Administrator reserves the right to determine whether a card or cardholder is
			eligible to participate in the program.
		</p>
	</div>



	<h2 (click)="toggleClass('5')" [ngClass]="{'open': show_description5}">Miles UpperClub REWARDS</h2>

	<div class="container" [ngClass]="{'show': show_description5}">
		<p>
			Miles UpperClub Rewards offers exclusive travel content to members when booking air flights,
			reserving hotels, car rental or entertainment/activities for the members trip. The members will
			also obtain and receive benefits and discounts when using Miles UpperClub program. These
			include enjoying a Best-Price Guarantee, access to Travel Protection and earning rewards
			when redeeming and purchasing travel experiences through the platform. Members will also
			have access to instantly redeem reward balances at over 46 million merchants worldwide using
			the Miles Card (further detailed below). With Miles UpperClub you earn up to 3X rewards on all
			you spend and redeem even when paying with rewards.
		</p>
		<p>
			Miles UpperClub Rewards may not be sold from the member&#39;s Miles UpperClub account. If the
			card associated with your Miles UpperClub account is a commercial product issued to you in
			your capacity as an employee or contractor, you will receive the rewards and be eligible to
			redeem them for rewards, and not your company and/or employer.
		</p>

		<p>
			In nor event, the card network or the Issuer of your card on file will be liable to any participant or
			anyone claiming through a Miles UpperClub program for any direct, indirect or consequential
			damages, or lost revenue or profits, arising out of card network’s or the Issuer’s acts or
			omissions in connection with the Miles UpperClub account.
		</p>

		<p>
			If the Miles UpperClub Administrator improperly denies or fails to credit rewards duly earned by
			you for qualifying purchases or any other Miles UpperClub benefit, your exclusive remedy will
			be the issuance of the improperly denied Miles UpperClub Rewards, rewards or benefit if available, or such other alternative comparable benefit as determined by Miles UpperClub
			Administrator.
		</p>
	</div>



	<h2 (click)="toggleClass('6')" [ngClass]="{'open': show_description6}">QUALIFYING PURCHASE</h2>

	<div class="container" [ngClass]="{'show': show_description6}">
		<p>
			A “Qualifying Purchase” is any type of travel purchase transaction processed through the Miles
			UpperClub platform with your card registered. Qualifying purchase amounts will be rounded to
			the nearest whole dollar amount to determine the number of rewards to be posted in your Miles
			UpperClub account. Rewards for qualifying purchases posted during a calendar month shall be
			eligible for immediate redemption. Any returns, credits, or chargebacks earn “negative” rewards
			such as “negative” rewards will reduce the total rewards posted to the Miles UpperClub account.
		</p>
		<p>
			Occasionally, the Miles UpperClub Administrator may authorize an adjustment to the member&#39;s
			rewards balance. These adjustments can be positive or negative; and at their sole discretion
			may modify the list of qualifying purchases from time to time.
		</p>
	</div>




	<h2 (click)="toggleClass('7')" [ngClass]="{'open': show_description7}">REWARDS POINTS REDEMPTION PROCESS</h2>

	<div class="container" [ngClass]="{'show': show_description7}">
		<p>
			Once travel reservation is completed the member is directed to the payment form and chooses
			the card registered on file, including Miles card, and/or available points that will be redeemed (if
			applied). The member will select how to pay for the transaction:
		</p>

		<ul>
			<li>- With available points only;</li>
			<li>- With Issuer Card on File only;</li>
			<li>- With available points and registered card on file.</li>
		</ul>
		<p>
			At this point, the member may also add a new card to complete the transaction. Once the
			redemption transaction completed, the member will be notified with the completion of the
			transaction including the number of rewards obtained for this purchase.
		</p>
		<p>
			Miles UpperClub rewards are redeemed on a “first-in, first-out” basis, the first rewards earned
			will be the first rewards redeemed over the life of the Miles UpperClub account. Once a
			redemption transaction is placed, the Miles UpperClub account will be reduced by the number
			of rewards used.
		</p>
		<p>
			Once the rewards transaction is issued, the process will consider finished. Rewards are not
			reimbursable, and no changes will be accepted. Once redeemed, rewards may not be replaced,
			reimbursed, and/or exchanged for cash, credit, or other rewards under any circumstances. All
			rewards reservations are subject to availability and must be booked through the platform. No
			other reservations will be accepted.
		</p>
		<p>
			Member must accept or reject any quote provided by Miles Administrator in the response date
			and time indicated on the quote, or in the platform redemption tool. Otherwise, the quote along
			with any reservation already made will be canceled, and the related rewards forfeited.
		</p>
		<p>
			If you decide to make additional arrangements to those provided by the rewards reservation,
			you are exclusively responsible for those arrangements, including but not limited to any costs
			associated with the additional arrangements or impact those arrangements have on the rewards
			reservation and/or your ability to exercise the rewards. If a merchant imposes a charge for
			cancellation or changes, members will be responsible for paying for those charges and may not
			do so using rewards.
		</p>

		<p>
			Members are solely responsible for obtaining the proper documentation, or any type of service
			to fill out and submit forms required by the authorities in each country. Also, members are solely
			responsible for obtaining and maintaining in their possession valid proof of citizenship or
			naturalization, immunization certificates, and/or visas required to travel or enter another country.
		</p>
	</div>




	<h2 (click)="toggleClass('8')" [ngClass]="{'open': show_description8}">Miles UpperClub BENEFIT</h2>

	<div class="container" [ngClass]="{'show': show_description8}">
		<p>
			Miles UpperClub rewards benefits are based on a points system that allows members to earn
			one point for each dollar or eligible equivalent amount in local currency charged to the card on
			file for qualifying purchases (each a “Rewards Point” or “Miles”), provided the card on file
			account is current. Rewards are earned whether transactions are made with card on file in full,
			with points only or with a combination of both (card on file and points).
		</p>
		<p>
			Member may redeem rewards at any time for all available content in the platform: air travel
			tickets, hotel stays, car rentals, and/or activities/entertainment (referred to generally as
			“Rewards”), and at 46 million merchants worldwide. As part of the Miles UpperClub benefit
			members get up to 3X miles on all you spend and redeem when paying with your rewards
			without limit and no expiration.
		</p>
		<p>
			Plus, there is no limit to how much rewards you can earn. Miles card helps you earn rewards
			over rewards. The more redemption you make with your Miles card in travel, hotels, cars, and/or
			activities/entertainment, and more miles you earn.
		</p>
		<p>
			Miles UpperClub account rewards balance and online redemption activity can be found at any
			time in the Miles UpperClub platform. Member can also inquire about rewards balances, points
			earned and online and offline redemption activity by contacting our interactive support team
			anytime through the Miles UpperClub platform.
		</p>
	</div>





	<h2 (click)="toggleClass('9')" [ngClass]="{'open': show_description9}">UPPERMILES</h2>

	<div class="container" [ngClass]="{'show': show_description9}">
		<p>
			UpperMiles is an exclusive benefit available in the Miles UpperClub program to its member.
			With UpperMiles you may earn points by making purchases on air travel tickets, hotel stays, car
			rentals, and/or activities/entertainment, and members get up to 3X miles on all spend and
			redemption when paying with rewards without limit and no expiration. Our members may earn
			additional points for buying miles. Also, it includes enjoying the best-price guarantee, access to
			travel protection, and earning rewards when redeeming and purchasing travel experiences
			through the platform.
		</p>
	</div>





	<h2 (click)="toggleClass('10')" [ngClass]="{'open': show_description10}">PAY WITH MILES</h2>

	<div class="container" [ngClass]="{'show': show_description10}">
		<p>
			Members can also use <strong>Miles</strong> to pay for purchases after the transaction by simply selecting the
			transaction and choosing to use miles from the rewards balance to pay for the purchase.
		</p>
		<p>
			As members of the <strong>Miles UpperClub</strong> program, and with your acceptance of the Privacy Policy
			and the Terms and Conditions described herein, you can enjoy and participate in the VISA
			Offers Platform (VOP) promotional offers program as part of the benefits included in <strong>Miles UpperClub</strong> by accepting the requirement established during the activation on the platform. You
			can have the choice to pay with your VISA card or preferred rewards, you can even combine
			some of them; online and in-store. For further convenience, you can customize your preferred
			payment sources and set a default ratio between them. When your enrollment is complete,
			<strong>Miles UpperClub</strong> Administrator can monitor transactions on the enrollment card. Every time
			you transact using your preferred card, we will check if that transaction is eligible to receive a
			promotional offer. If a qualifying transaction is detected, we will inform and provide you all the
			required details about the transaction inclusive offer redemption and statement credit. The
			member can then take action based on the notification.
		</p>
	</div>



	<h2 (click)="toggleClass('11')" [ngClass]="{'open': show_description11}">BUY MILES</h2>

	<div class="container" [ngClass]="{'show': show_description11}">
		<p>
			Members will be able to purchase additional miles which will be added to the rewards balance
			account.
		</p>
	</div>



	<h2 (click)="toggleClass('12')" [ngClass]="{'open': show_description12}">FORFEITURE OF REWARDS</h2>

	<div class="container" [ngClass]="{'show': show_description12}">
		<p>
			Positive rewards balance will be forfeited if:
		</p>
		<ul>
			<li>
				- The card on file in the Miles UpperClub account is canceled by the member or by the card issuer;
			</li>
			<li>
				- Miles UpperClub account is terminated by the member;
			</li>
			<li>
				- If the member death.
			</li>
		</ul>
		<p>
			Any fraud or abuse related to the rewards earned or redeemed will be canceled all rewards
			earned as result of it under the Miles UpperClub program, as well as the immediate cancellation
			of the Miles UpperClub Account.
		</p>

		<p>
			Members can change their card on file at any time having no impact in their Miles UpperClub account or member&#39;s rewards balance.
		</p>
	</div>




	<h2 (click)="toggleClass('13')" [ngClass]="{'open': show_description13}">EXPIRATION OF REWARDS</h2>

	<div class="container" [ngClass]="{'show': show_description13}">
		<p>
			Miles UpperClub Rewards will not expire in your Miles UpperClub account. If necessary, Miles UpperClub Administrator holds the right to modify rewards expiration rules anytime.
		</p>
		<p>
			When your rewards are forfeited for any reason, you are not entitled to compensation from Miles UpperClub Administrator, neither the card network nor any other entity.
		</p>
	</div>




	<h2 (click)="toggleClass('16')" [ngClass]="{'open': show_description16}">REWARDS DISCLAIMERS AND LIMITATIONS</h2>

	<div class="container" [ngClass]="{'show': show_description16}">
		<p>
			Miles UpperClub program is not available under any circumstances for travel, hotels, car
			rentals, or any other type of benefit or service related to Cuba, Iran, Syria, and Sudan or any
			other country with international sanctions currently in force. U.S. laws prohibit card networks
			from providing or facilitating any benefits or services related to Cuba, Iran, Syria, or Sudan,
			including but not limited to the redemption of Miles UpperClub Rewards for benefits or services
			related to those countries. Please be aware of these limitations before making travel
			arrangements or using your card on file, and any benefits restrictions, that may apply in those
			countries. Exceptions to this prohibition are not permitted.
		</p>
		<p>
			Miles UpperClub reserves the right to modify or cancel the rewards benefit points at any time,
			and the service providers and/or merchants reserve the right to cancel their participation in the
			program at any time. This may result in the cancellation of any existing rewards balance for
			which the service providers and/or merchants shall not be liable.
		</p>
		<p>
			Published rewards levels are subject to change due to fluctuations in currency exchange rates,
			customs charges, taxes, other charges and fees imposed by governments, and fuel surcharges.
			Changes may also include, but are not limited to:
		</p>

		<ul class="point">
			<li>The number of rewards you earn for a particular type of activity;</li>
			<li>The number of rewards you need to reach a particular rewards tier or to redeem particular rewards;</li>
			<li>Omitting or adding rewards levels or categories;</li>
			<li>Changing the selection of rewards;</li>
			<li>Imposing, increasing or eliminating rewards caps;</li>
			<li>Changing the conditions under which rewards expire or are forfeited payments of existing
				card balances, balance transfers, cash advances, cash withdrawals of any kind, card fees,
				currency conversion fees, transaction fees, coverage fees, returned items for which credit
				was issued, purchases that for any reason violate the law or the Card Agreement,
				unauthorized charges and other types of fees that are not qualifying purchases.</li>
		</ul>

		<p>The Issuer, the card network, and the service providers are not responsible with members for
			the quality or performance of the rewards, the products/services obtained with the rewards, and
			any act or omission by the provider of rewards, availability of rewards, whether redeemed or
			otherwise, disputes between authorized members regarding the miles or for any other reason.
			Neither the Issuer nor card network makes any guarantee or representation of any kind,
			express or implied, concerning the rewards, including but not limited to warranties of
			merchantability or fitness for a particular purpose.
		</p>
		<p>
			The Issuer and the card network are not liable for any injury, damage or loss to person or
			property or any expense, accident or inconvenience that may arise from the use of the rewards, products/services, or merchandise purchased obtained with the rewards, or otherwise in connection with the Miles UpperClub.
		</p>
		<p>
			The Issuer and the card network are not responsible for merchants, manufacturers, or other
rewards providers that discontinue or cancel a reward due to bankruptcy or for any other
reason. Neither the Issuer nor the card network makes any representation or endorsement of
any rewards, merchant, or another provider of rewards in connection with Miles UpperClub.
		</p>
		<p>
			If participating in the Miles UpperClub program offered via a mobile device, the wireless
provider’s message and data rates may apply and members will be responsible for any such
charges from wireless providers.
		</p>
		<p>
			The Issuer, the card network, and the participating merchants are not responsible for replacing
lost, stolen, or damaged rewards.
		</p>
		<p>
			Travel-related rewards will be treated as if purchased with the card on file associated with your
			Miles Account, so that benefits (including but not limited to travel accident or loss of vehicle
			coverage, if applicable) available to you for purchases with your card on file will apply to
			rewards, as long as all taxes, charges and/or fees charged to you in connection with your
			redemption and/or utilization of the rewards are paid for in full with your card on file. You are
			solely responsible for reading and understanding the Terms and Conditions applicable to those
			benefits to maintain your eligibility in connection with the rewards. For any questions regarding
			the benefits available to you, please contact Miles UpperClub customer service.
		</p>
	</div>



	<h2 (click)="toggleClass('17')" [ngClass]="{'open': show_description17}">Miles BEST-PRICE GUARANTEE</h2>

	<div class="container" [ngClass]="{'show': show_description17}">
		<ul class="text-normal">
			<li>
				<h3>BEST-PRICE GUARANTEE BENEFIT</h3>
				<p>
					Miles UpperClub members will enjoy Best-Price Guarantee when booking travel based on the
					agreements with Miles UpperClub travel service providers.
				</p>
				<ul class="number">
					<li>
						<strong>Price Guarantee for Air flight.</strong>
						In the event of a lower rate available in Miles UpperClub or on another country-based website
						within 24 hours of booking with Miles upperClub, will credit or refund the difference in price.
					</li>
					<li>
						<strong>Price Guarantee for Hotels.</strong>
						In the event of a lower rate available in Miles UpperClub or on another country-based website
						up to 11:59 pm Pacific 48 hours after completing the hotel booking, Miles UpperClub will credit
						or refund the difference in price.
					</li>
				</ul>
			</li>
			<li>
				<h3>BEST-PRICE GUARANTEE RULES &amp; CONDITIONS</h3>
				<p>
					The trip must be completed as per booked itinerary through the mobile app or, if available, via
					the Website’s online redemption system to be eligible for refund or credit.
				</p>

				<p>
					Member must file a Price Guarantee application form through the Miles UpperClub platform
					within twenty-four (24) hours after the booking, or for hotels, within forty-eight-(48) hours after
					completing the booking. The lower rate must be available for booking at the time of contact.
					Each credit is valid for one (1) year from month of issuance. Price Guarantee is available only
					for exact itinerary matches.
				</p>
				<p>
					Price Guarantee applies only to prices both advertised and available to the public on an English
					and Spanish-language website. For example, it does not apply to rates offered on:
				</p>
				<ul class="number">
					<li>Membership program websites, corporate discounts or rates;</li>
					<li>Group, charter, rewards program, incentive, meeting, convention, consolidator or interline prices;</li>
					<li>Prices obtained via auction or similar process;</li>
					<li>Prices available only by using a coupon or other promotion not offered to the general public.</li>
				</ul>
				<p>
					The lower rate may not come from a website where member called to get the rate, or from an e-
					mail received. Additionally, the rate must be quoted, booked, and paid for in US dollars.
				</p>
				<p>
					All Price Guarantee requests, including receipts, are subject to verification by Miles
					Administrator. The Program Administrator will not accept screenshots or other purported
					evidence of a lower price that cannot be independently confirmed by program personnel.
				</p>
			</li>
		</ul>
	</div>




	<h2 (click)="toggleClass('18')" [ngClass]="{'open': show_description18}">Miles UpperClub PROTECTION</h2>

	<div class="container" [ngClass]="{'show': show_description18}">
		<p>
			Miles UpperClub enables the protection benefits described in this document, and subject to the
			following:
		</p>
		<ul class="number">
			<li>All terms, conditions, provisions, and exclusions established of this document, including
				any applicable Exhibits, Schedules, and/or Endorsements;</li>
			<li>Current subscription to the Miles UpperClub platform;</li>
			<li>Any enrollment associated fees (if applicable).</li>
		</ul>
		<p>
			Only new trips commenced after the date the member has been advised cover commences are covered.
		</p>
		<p>
			ClickHelpNet, LLC has been appointed as the Claims Administrator. All communications,
			notices, and payment of claims required under this cover shall be transmitted to and from the
			Covered Person through the Claims Administrator.
		</p>
	</div>





	<h2 (click)="toggleClass('19')" [ngClass]="{'open': show_description19}">Miles UpperClub COMMUNICATIONS</h2>

	<div class="container" [ngClass]="{'show': show_description19}">
		<p>
			Miles UpperClub may communicate with members for any matters related to the program via
			telephone, electronic mail, or push notifications. To update, change, modify, or delete your
			information or to change the consent to receive these promotions, members shall contact Miles
			UpperClub Administrator using the information provided in the Miles UpperClub platform.
		</p>
		<p>
			To access Miles UpperClub website members will need a Windows or Apple compatible
			computer, Internet access, a browser such as Microsoft Internet Explorer V. 8.0 or later, Google
			Chrome or Mozilla Firefox, and an e-mail account. Additionally, must have a password to
			access their information electronically or to conduct any online activity related to the Miles
			UpperClub account on the Website.
		</p>
		<p>
			By becoming a member of the Miles UpperClub program, members authorize Miles UpperClub
			Administrator to use information related to the participation and the Miles UpperClub account
			(and information provided by you to participate in the Miles UpperClub program) to customize
			the Miles UpperClub experience. This may include communicating special offers, featured
			rewards opportunities, and customizing the promotional information (if chosen to receive such
			promotions).
		</p>
		<p>
			If members would like to request a paper copy of these terms and conditions or to withdraw the
			consent to receive electronic communications, they have to contact the Miles UpperClub
			Customer Service using the information provided in the mobile application. If using the Website,
			Miles UpperClub Administrator is not obligated to provide any additional hard copy
			communications other than these Terms and Conditions.
		</p>
	</div>




	<h2 (click)="toggleClass('20')" [ngClass]="{'open': show_description20}">Miles UpperClub CUSTOMER SERVICE</h2>

	<div class="container" [ngClass]="{'show': show_description20}">
		<p>
			Members may contact Miles UpperClub Customer Service via chat or video conference call
			through the Miles UpperClub platform. The Miles UpperClub Customer Service is available
			Monday through Friday from 7:00 a.m. to 7:00 p.m. (Eastern Standard Time). Miles UpperClub
			reserves the right to modify customer service hours at any time and without notice.
		</p>
		<p>
			These inquiries may include – but are not limited to – a number of earned rewards of a
			particular purchase or transaction, redemption orders status and any questions or concerns
			related to the Miles UpperClub.
		</p>
		<p>
			In case of member contact, their card issuer regarding the Miles UpperClub account, Miles
			UpperClub Administrator will use reasonable efforts to investigate and correct the error or
			mistake, subject to the limitations set forth in these Terms and Conditions. In any event,
			members must notify Miles UpperClub Administrator within 60 days of the posting date (or the
			date of the alleged error or mistake) to undertake an investigation of the matter.
		</p>
		<p>
			Miles UpperClub Administrator may request members to provide written confirmation of the
			alleged error or mistake. If Miles UpperClub Administrator does not receive the requested
			written confirmation within the requested timeframe, Miles UpperClub Administrator may
			determine not to correct the alleged error, or mistake. If Miles UpperClub Administrator
			completes the investigation of the alleged error or mistake and notifies members of the
			determination, Miles UpperClub Administrator has no further responsibilities should member
			later reassert the same alleged error or mistake.
		</p>
		<p>
			All questions or disputes regarding the Miles UpperClub program, including eligibility, earning
			points, or redemption of points for rewards, will be resolved by the Miles UpperClub
			Administration at their sole discretion.
		</p>
		<p>
			If member contacts Miles UpperClub Administrator via a mobile device, member wireless
			provider’s message and data rates may apply, and member is responsible for any such charges
			from wireless provider.
		</p>
	</div>




	<h2 (click)="toggleClass('21')" [ngClass]="{'open': show_description21}">Miles CANCELLATION</h2>

	<div class="container" [ngClass]="{'show': show_description21}">
		<p>
			Members can cancel Miles UpperClub program at any time by contacting the Miles UpperClub
			Administrator through the platform. The positive rewards balance in the Miles UpperClub
			account will be forfeited. The card on file card network or the Issuer cannot cancel the Miles
			UpperClub program.
		</p>
	</div>



	<h2 (click)="toggleClass('22')" [ngClass]="{'open': show_description22}">Miles TERMS AND CONDITIONS DISCLAIMERS AND LIMITATIONS</h2>

	<div class="container" [ngClass]="{'show': show_description22}">
		<p>
			Miles UpperClub Administrator will notify members of any material changes to the Miles
			UpperClub Terms and Conditions unless the member decides to terminate the Miles UpperClub
			program, members will be bound by the revised Terms and Conditions.
		</p>
	</div>



	<h2 (click)="toggleClass('23')" [ngClass]="{'open': show_description23}">Miles UpperClub SECURITY</h2>

	<div class="container" [ngClass]="{'show': show_description23}">
		<p>
			Miles UpperClub platform protects your data that will be safe thanks to our encryption process
			designed to avoid fraud.
		</p>
	</div>
</div>
